import { CloneParticipantsObject } from './types/cloneParticipantsObject.types'

export const cloneParticipantsObject: CloneParticipantsObject = (
  participants
) => (
  JSON.parse(JSON.stringify(participants))
)
